<script setup lang='ts'>
import type { BlockquoteIntent, BlockquoteSize } from '~/utils/blockquote'
import { faChevronsLeft } from '@fortawesome/pro-solid-svg-icons'
import { blockquoteVariants } from '~/utils/blockquote'

withDefaults(
  defineProps<{
    variant?: BlockquoteIntent
    size?: BlockquoteSize
    author?: {
      name: string
      role?: string | null
    }
  }>(),
  {
    variant: 'filled',
    size: 'large',
  },
)
</script>

<template>
  <div :class="blockquoteVariants.base({ intent: variant, size })">
    <Icon v-if="size === 'large'" :icon="faChevronsLeft" size="sm" class="mt-[0.425rem] text-blurple-300" />
    <div class="flex flex-col gap-s">
      <component
        :is="size === 'small' ? 'q' : 'blockquote'"
        :data-size="size"
        :class="blockquoteVariants.content({
          intent: variant,
          size,
        })"
      >
        <slot />
      </component>
      <div v-if="author" :class="blockquoteVariants.author({ intent: variant, size })">
        <span>{{ author.name }}</span>
        <span v-if="author.role" class="text-caption">{{ author.role }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
[data-size='small'] > * {
  @apply inline before:content-["_"];

  &:first-of-type {
    @apply before:content-[""];
  }
}
</style>
